import Input from './Input';
import { InputVariants } from './Input';

export { InputVariants };
export default Input;
